import { Component, OnInit, Input } from '@angular/core';
import { LaunchDarklyService } from '../../../../context-discovery-services/services/launch-darkly.service';
import { FeatureFlags } from '../../../../context-discovery-services/constants/feature-flags.const';

@Component({
  selector: 'adminapp-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss']
})
export class MasterPageComponent implements OnInit {

  @Input() loading = false;
  @Input() customizeMasterBodyStyle = false;
  isUnifiedFlowEnabled: boolean;
  launchDarklySubscription: any;

  constructor(private ldService: LaunchDarklyService) {
    this.isUnifiedFlowEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW);
    this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
      this.isUnifiedFlowEnabled = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW, true);
    });
   }

  ngOnInit() {
  }

  canBeRealignedForUnifiedWorkflow() {
    return !this.customizeMasterBodyStyle && this.isUnifiedFlowEnabled;
  }
}
